var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 12,
  x: 3.5,
  y: 4.5,
  stroke: "currentColor",
  rx: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 8h14v1H3z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 4,
  x: 6,
  y: 2,
  fill: "currentColor",
  rx: 0.75
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 4,
  x: 13,
  y: 2,
  fill: "currentColor",
  rx: 0.75
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  x: 6,
  y: 11,
  fill: "currentColor",
  rx: 0.75
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  x: 10,
  y: 11,
  fill: "currentColor",
  rx: 0.75
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  x: 14,
  y: 11,
  fill: "currentColor",
  rx: 0.75
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  x: 6,
  y: 14,
  fill: "currentColor",
  rx: 0.75
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  x: 10,
  y: 14,
  fill: "currentColor",
  rx: 0.75
})));
export default SvgCalendar;